export default "__VITE_ASSET__dUBjEeeU__"